module.exports = __webpack_public_path__ + "static/album-the-source.e60210da.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/album-the-source.jpg
// module id = 1320
// module chunks = 4